import 'moment/locale/pt';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { enUS, ptPT } from '@mui/x-date-pickers/locales';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

const localeMap: Record<string, typeof enUS> = {
  pt: ptPT,
  'pt-PT': ptPT,
  en: enUS,
  'en-US': enUS,
};

type Props = {
  children: ReactNode;
};

const I18nLocalizationProvider = ({ children }: Props) => {
  const { i18n } = useTranslation();

  const muiLocale = localeMap[i18n.language] ?? enUS;

  return (
    <LocalizationProvider
      dateAdapter={AdapterMoment}
      adapterLocale={i18n.language}
      localeText={
        muiLocale.components.MuiLocalizationProvider.defaultProps.localeText
      }
    >
      {children}
    </LocalizationProvider>
  );
};

export default I18nLocalizationProvider;
